<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!tax">
      <span class="loader"></span>
    </span>
    <tax-form
      v-if="tax"
      :loading="loading"
      :taxData="tax"
      :formErrors="formErrors"
      @taxSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import TaxForm from "../partials/TaxForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { TaxForm },

  mixins: [alertLeave],

  props: {
    taxId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      tax: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("taxes/get", this.taxId);
        this.tax = this.$store.getters["taxes/tax"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(tax) {
      this.loading = true;
      const taxData = cloneDeep(tax);

      try {
        await this.$store.dispatch("taxes/update", taxData);
        this.$notify({
          type: "success",
          message: this.$t("TAXES.TAX_UPDATED"),
        });
        const tax = await this.$store.getters["taxes/tax"];
        this.$emit("onViewTax", tax, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
